import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import App from "./App.vue";
import VueRouter from "vue-router";
import router from "./router/index.js";
import store from "./store/index.js";
import Echarts from "echarts";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import setTime from "@/components/setDate.js";
import permission from "./directive/permission";
import global from "@/utils/global.js";
import { calculateDifference }  from "@/utils/index.js";
import { selectDictLabel } from "@/utils/ruoyi";
//import './permission' // permission control
import echarts from "echarts";
import Vant from "vant";
// import Print from "vue-print-nb";
import "vant/lib/index.css";

// 将自动注册所有组件为全局组件
import dataV from "@jiaminghi/data-view";

Vue.use(dataV);

import proportion from "vue-proportion-directive";
Vue.use(proportion);

import VueCookies from "vue-cookies";
Vue.use(VueCookies);

import Print from "@/plugs/print";
// Vue.use(PrintMy); // 注册

Vue.use(Print);

Vue.use(Vant);

Vue.use(permission);

import { Loading } from "element-ui";
var loadingInstance = null;

var options = {
  lock: true,
  text: "Loading",
  spinner: "el-icon-loading",
  background: "rgba(0, 0, 0, 0.7)",
};

Vue.prototype.selectDictLabel = selectDictLabel;
Vue.prototype.calculateDifference = calculateDifference;
Vue.prototype.$echarts = echarts;
Vue.prototype.$global = global;
Vue.prototype.setTime = setTime.setTime;
axios.defaults.crossDomain = true;
axios.defaults.withCredentials = true;
axios.interceptors.request.use(
  (config) => {
    //让每个请求都携带请求头
    if(config.url != "/api/message/getMessage"&&config.url != "/api/screen/getPendingCount"){
      loadingInstance = Loading.service(options);
    }
    if (
      localStorage.access_token &&
      config.url != "/user/resetPassWord" &&
      config.url != "/api/checkInApply/addCheckInApply" &&
      config.url != "/api/ownerManage/getOwnerName"
    ) {
      config.headers["Authorization"] = "Bearer " + localStorage.access_token;
      config.headers.common["token"] = localStorage.access_token;
      VueCookies.set("JSESSIONID", localStorage.cook);
      // var str = ""
      // JSON.parse(localStorage.roles).forEach(item => {
      // 	str ="/" + item
      // })
      // config.url = str + config.url;
    }
    config.headers["Content-Type"] = "application/json";
    // config.timeout=60000;
    var a = config.url.split("/");

    var k = 1;
    a.forEach((val) => {
      if (val == "flow") {
        k = 2;
        return;
      }
    });

    if (
      config.url.indexOf("/safe") == -1 &&
      config.url.indexOf("/api/system/config/list") == -1 &&
      config.url != "/api/code" &&
      config.url.indexOf("/passengerFlow/queryEarningById") == -1 &&
      config.url != "/api/auth/login" &&
      config.url != "/api/system/user/getInfo" &&
      config.url != "/api/system/menu/getRouters" &&
      config.url != "/api/system/dept/treeselect2" &&
      config.url != "/api/system/user/list" &&
      config.url != "/api/auth/logout" &&
      k == 1 &&
      config.url != "/api/system/role/list2/list2" &&
      config.url != "/api/system/user/add" &&
      config.url != "/api/system/user/edit" &&
      config.url != "/api/system/post/list2/list2" &&
      config.url != "/api/system/user/list2" &&
      config.url != "/api/system/user/delete" &&
      config.url != "/api/system/role/authUser/allocatedList" &&
      // config.url.indexOf("/api/bdRepairApply/saveRepairApply") == -1 &&
      config.url != "/api/system/dict/data/type/invoiceStatus"
    ) {
      // var str = ""
      // JSON.parse(localStorage.roles).forEach(item => {
      // 	str ="/" + item
      // })
      config.url = "/api" + "/admin" + config.url.split("/api")[1];
    }

    if (config.method === "get" && config.params) {
      // let url = config.url + '?' + tansParams(config.params);
      // url = url.slice(0, -1);
      // config.params = {};
      // config.url ="http://172.16.1.140:8088"+ url;
      let url = config.url + "?";
      for (const propName of Object.keys(config.params)) {
        const value = config.params[propName];
        var part = encodeURIComponent(propName) + "=";
        if (value !== null && typeof value !== "undefined") {
          if (typeof value === "object") {
            for (const key of Object.keys(value)) {
              let params = propName + "[" + key + "]";
              var subPart = encodeURIComponent(params) + "=";
              url += subPart + encodeURIComponent(value[key]) + "&";
            }
          } else {
            url += part + encodeURIComponent(value) + "&";
          }
        }
      }
      url = url.slice(0, -1);
      config.params = {};
      config.url = url;
    }

    return config;
  },
  (error) => {
    loadingInstance.close();
    return error;
  }
);

axios.interceptors.response.use(
  (response) => {
    loadingInstance.close();
    // VueCookies.set("JSESSIONID",localStorage.cook)

    // if (response.data.code == 200) {
    // 	setTimeout(r => {
    // 		sessionStorage.code = 200
    // 	}, 1000)
    // }
    if (response.data.code == 401) {
      sessionStorage.clear();
      sessionStorage.code = 401;
      router.push("/login");
    }
    return response;
  },
  (error) => {
    loadingInstance.close();
    if (error.response.status == 401) {
      ElementUI.Message.warning("无权限");
      sessionStorage.clear();
      router.push("/login");
    }
    return error;
  }
);
/////

Vue.config.productionTip = false;
Vue.prototype.echarts = Echarts;
Vue.use(Echarts);
Vue.use(VueRouter);

// 解决报错
const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;
// push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};
// replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch((err) => err);
};

Vue.use(VueAxios, axios);
Vue.use(ElementUI);
new Vue({
  render: (h) => h(App),
  router,
  store,
}).$mount("#app");

/**
 * 监听缓存(webstorage)
 * @param { number } type 1 localStorage   2 sessionStorage
 * @param { string } key 键
 * @param { string } data 要存储的数据
 * @returns
 */
Vue.prototype.$addStorageEvent = function (type, key, data) {
  if (type === 1) {
    // 创建一个StorageEvent事件
    var newStorageEvent = document.createEvent("StorageEvent");
    const storage = {
      setItem: function (k, val) {
        localStorage.setItem(k, val);
        // 初始化创建的事件
        newStorageEvent.initStorageEvent(
          "setItem",
          false,
          false,
          k,
          null,
          val,
          null,
          null
        );
        // 派发对象
        window.dispatchEvent(newStorageEvent);
      },
    };
    return storage.setItem(key, data);
  } else {
    // 创建一个StorageEvent事件
    var newStorageEvent = document.createEvent("StorageEvent");
    const storage = {
      setItem: function (k, val) {
        sessionStorage.setItem(k, val);
        // 初始化创建的事件
        newStorageEvent.initStorageEvent(
          "setItem",
          false,
          false,
          k,
          null,
          val,
          null,
          null
        );
        // 派发对象
        window.dispatchEvent(newStorageEvent);
      },
    };
    return storage.setItem(key, data);
  }
};
